﻿/* global FS */

var grecaptcha = window.grecaptcha;

function initRecaptcha(fid, name, siteKey) {
	if (!fid) {
		console.error("Expected form id");
		return;
	}
	if (!name) {
		console.error("Expected name");
		return;
	}
	if (!siteKey) {
		console.error("Please include reCAPTCHA API script with render=<site key> parameter first!");
		return;
	}
	function hookForm() {
		var oldFormSubmit = FS.Form.submit;
		function newFormSubmit(form, d) {
			if (!form.elements)
				form = form[0];
			if (form.id == fid && (!form.checkValidity || form.checkValidity())) {
				var grt = form.elements[name];
				if (grt) {
					grecaptcha.ready(function () {
						grecaptcha.execute(siteKey, { action: 'submit' }).then(function (token) {
							grt.value = token;
							oldFormSubmit(form, false);
						});
					});
					return false;
				}
			}
			return oldFormSubmit(form, d);
		}
		FS.Form = { ...FS.Form, submit: newFormSubmit };
	}
	if (!grecaptcha) {
		FS.addScript("https://www.google.com/recaptcha/api.js?render=" + siteKey, function () {
			grecaptcha = window.grecaptcha;
			hookForm();
		});
	} else {
		hookForm();
	}
}

export { initRecaptcha };
